import script from "./products.vue?vue&type=script&setup=true&lang=js"
export * from "./products.vue?vue&type=script&setup=true&lang=js"

import "./products.vue?vue&type=style&index=0&id=5927dc56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5927dc56"]])

export default __exports__